'use strict';

import React from 'react';
// import ReactDOM from 'react-dom/client';

import PopupAlert from '../components/PopupAlert';
// import BigTile from '../react/agenda/components/AgendaContent/BigTile';
import config from '../react/agenda/Config';
import { updateCookieWishlist as UpdateWishList } from '../components/Favourites';

document.querySelectorAll('#wishlist').forEach((el) => {
	if ( 1 == parseInt(customData?.debug) ) {
		console.log('Checking wishlist...');
	}

	// match login cookie
	let match = document.cookie.match(new RegExp('(^| )' + ( customData?.cookieContactId ?? null ) + '=([^;]+)'));
	match = null === match ? '' : match[2];
	let isLoggedIn = match ? true : false;
	let customValues = '';
	let search = window.location.search;

	const clearList = document.querySelector('.wishlist__clear-result-content');
	const shareList = document.querySelector('.wishlist__share-content');

	// only show message when not logged in
	document.querySelectorAll('.wishlist__message').forEach((el) => {
		if ( String(el.dataset.logged_in) === String(isLoggedIn) ) {
			el.style.display = 'flex';
		}
	})

	document.querySelectorAll('.js-popup-alert').forEach((el) => {
		new PopupAlert(el);
	})

	if ( search.indexOf('?ids=') > -1 && search.replace('?ids=','')!='') {
		if ( 1 == parseInt(customData?.debug) ) {
			console.log('Generate wishlist detected...');
		}
		customValues = search.replace('?ids=','').split(',');
		loadWishlist();
	} else {
		loadWishlist();
	}

	// remove wishlist action
	clearList.querySelector('button').addEventListener('click', () => {
		UpdateWishList([-1],[]);
		window.location.reload();
	})

	// remove wishlist action
	shareList.querySelector('form').addEventListener('submit', (e) => {
		e.preventDefault();
		shareWishlist(e);
	})

	function shareWishlist(form) {
		if (!window.XMLHttpRequest) {
			return;
		}

		try {
			var xhr = new XMLHttpRequest();
			xhr.previous_text = '';
			xhr.responseType = "json";

			xhr.onerror = function() {
				console.log('XHR error');
			}
			xhr.onreadystatechange = function() {
				try {

					if (this.readyState == 4 && this.status == 200) {
						if (this.response.errors) {
							shareList.querySelector('.popup-alert__error').innerHTML = this.response.html;
						} else {
							shareList.querySelectorAll('input').forEach((el) => {
								el.style.display = 'none';
							})
							shareList.querySelector('button').style.display = 'none';
							shareList.querySelector('.popup-alert__error').innerHTML = this.response.html;
							setTimeout(function() {
								form.target.reset();
								shareList.querySelector('.popup-alert__error').innerHTML = '';
								shareList.querySelectorAll('input').forEach((el) => {
									el.removeAttribute('style');
								})
								shareList.querySelector('button').removeAttribute('style');
							}, 5000);
						}
					}

				} catch (e) {
					console.log(e);
				}
			}

			let formdata = new FormData(form.target);
			let params = '';
			params += '&name_from=' + encodeURIComponent( formdata.get('name_from') ?? '' );
			params += '&email_from=' + encodeURIComponent( formdata.get('email_from') ?? '' );
			params += '&email_to=' + encodeURIComponent( formdata.get('email_to') ?? '' );

			xhr.open('POST', customData.ajaxUrl, true);
			xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
			xhr.send('action=share_wishlist' + params);
		} catch (e) {
			console.log('XHR failed request');
		}
	}

	function loadWishlist() {
		if (!window.XMLHttpRequest) {
			return;
		}

		try {
			var xhr = new XMLHttpRequest();
			xhr.previous_text = '';
			xhr.responseType = "json";

			xhr.onerror = function() {
				console.log('XHR error');
			}
			xhr.onreadystatechange = function() {
				try {
					if (this.readyState == 4 && this.status == 200) {
						el.innerHTML = this.response.html;

						if (this.response.items && this.response.items > 0 && customValues.length == 0 ) {
							document.querySelector('.wishlist__clear-result').classList.add('active');
							document.querySelector('.wishlist__share-button').classList.add('active');
						}

						if ( customValues.length > 0 ) {
							document.querySelector('.wishlist__back-button').classList.add('active');
						} else {
							document.querySelector('.wishlist__basket-button').classList.add('active');
						}
console.log( 'hey' );
						// if (el.contains(document.querySelector('.js_react_tile'))) {
						// 	el.querySelectorAll('.js_react_tile').forEach((movie, index) => {
						// 	let event = Object.values(JSON.parse(decodeURIComponent(movie.dataset.event)))[0];

						// 	const root = ReactDOM.createRoot(movie);
						// 	root.render(
						// 		<BigTile
						// 			movie={event}
						// 			first
						// 			id={index}
						// 			currentConfig={config}
						// 		/>
						// 	);
						// 	});
						// }
					}
				} catch (e) {
					console.log(e);
				}
			}
			let params = '&paged=' + (el.dataset.paged ?? 0);
			if ( customValues.length > 0 ) {
				params += '&ids=' + customValues.join(',');
			}
			xhr.open('POST', customData.ajaxUrl, true);
			xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
			xhr.send('action=get_wishlist' + params);
		} catch (e) {
			console.log('XHR failed request');
		}
	}
})
